const userSettingsApi = '/userSettings';

export const unsubscribeTTRemindersPath = () =>
  `${userSettingsApi}/unsubscribe-from-reminders`;
